import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {  useForm } from "react-hook-form";
import AuthLayout from "../../components/layouts/auth-layout";
import SideImage from "../../assets//images/sideImage.png"
import Button from "../../components/button";
import useRequest from "../../components/hook/use-req";
import { ClockLoader } from "react-spinners";
import { toast } from "sonner";

// ── Google G SVG ────────────────────────────────────────────────────────────
const GoogleIcon = () => (
  <img
    src="https://www.svgrepo.com/show/475656/google-color.svg"
    alt="Google"
    className="w-5 h-5 mr-3"
  />
);



// ─── VerifyResetPassword ─────
const VerifyResetPassword = () => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const { handleSubmit } = useForm();
  const [timer, setTimer] = useState(30);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const email = localStorage.getItem("resetEmail");
  const { loading: loader, makeRequest: resendOtp } = useRequest("/auth/resend-otp", "POST");
  const navigate = useNavigate();
  const { loading, makeRequest } = useRequest("/auth/verify-password-otp", "POST");
  const [resendEnabled, setResendEnabled] = useState(false);
  
  const handleCodeChange = (index: number, value: string) => {
    if (!/^\d*$/.test(value)) return; 

    if (value?.length <= 1) {
      const newCode = [...otp];
      newCode[index] = value;
      setOtp(newCode);

      if (value && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text")?.slice(0, 6);
    if (!/^\d+$/.test(pastedData)) return;

    const newOtp = pastedData.split("")?.slice(0, 6);
    setOtp(newOtp);

    const nextEmptyIndex = newOtp.findIndex((val) => val === "");
    if (nextEmptyIndex !== -1) {
      inputRefs.current[nextEmptyIndex]?.focus();
    } else {
      inputRefs.current[5]?.focus();
    }
  };

useEffect(() => {
  if (timer <= 0) {
    setResendEnabled(true);
    return;
  }

  const interval = setInterval(() => {
    setTimer((t) => t - 1);
  }, 1000);

  return () => clearInterval(interval);
}, [timer]);


  const handleVerification = handleSubmit(async () => {
    const code = otp.join("");
    if (code.length !== 6) {
  toast.error("Please enter the 6-digit code");
  return;
}
    const user = { code: code, email: email };
    const [response] = await makeRequest(user); 
    if (response.success) {
      toast.success(response.message);
      navigate("/reset-password");
    } else {
      toast.error('Invalid or expired session');
    }
  });

  const handleResend = async () => {
       const userEmail = {  email: email };
    const [response] = await resendOtp(userEmail);
    if (response?.success) {
      toast.success(response.message);
    } else {
      const errorMsg =
        typeof response?.message === "string"
          ? response.message || 'Invalid or expired session'
          : response.message || "Invalid or expired session.";
      toast.error(errorMsg);
    }
  };

  useEffect(() => {
  const code = otp.join("");
  if (code.length > 0) {
    localStorage.setItem("resetOtpCode", code);
  }
}, [otp]);

  return (
    <AuthLayout sideImageSrc={SideImage}>
      {/* Header */}
      <div className="mb-32">
        <h1 className="text-[32px] font-bold text-[#3A3428] dark:text-gray-100">Welcome to <span className="font-medium">ConvoHub</span></h1>
        <p className="text-[16px] text-[#434343] dark:text-gray-400">Reach customers on every channel, effortlessly.</p>
      </div>

      {/* Form */}
      <div  className="space-y-4">
         <div className="mb-6">
                  <h3 className="font-semibold text-gray-900 dark:text-gray-100">Enter the 6-digit code</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                    We sent a 6-digit code to <strong> {email}</strong>
                  </p>

                  <div className="flex  lg:gap-3 gap-2 mb-4 justify-center sm:justify-start">
                    {otp.map((digit, index) => (
                      <input
                        key={index}

                        ref={(el) => {
                          inputRefs.current[index] = el;
                        }}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleCodeChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        onPaste={handlePaste}
                        className="w-[69px] h-[60px] sm:w-14 sm:h-14 text-center text-2xl font-bold border-2 border-gray-300 dark:border-gray-600 hover:border-blue-600 rounded-[4px] focus:border-blue-600 outline-none transition-all bg-white dark:bg-transparent text-gray-900 dark:text-gray-100"
                      />
                    ))}
                  </div>

                  <div className="flex items-center justify-between text-sm text-[#333D4D] dark:text-gray-300 font-medium">
                    <div>
                      {resendEnabled ? (
                        <div className="flex gap-36">
                          <button
                            onClick={handleResend}
                            className="hover:text-teal-600 block "
                          >

                            {loader ? (
                              "Resending..."
                            ) : (
                              <span className="text-[#434343] dark:text-gray-300 text-[16px] font-medium">
                                Didn’t receive the code? <span className="underline text-[#4338CA] dark:text-indigo-400">Send again</span>
                              </span>

                            )}
                          </button>
                          {/* <button
                            onClick={() => navigate("/signup")}
                            className="hover:text-teal-600 block hover:underline"
                          >
                            Edit WhatsApp Number
                          </button> */}
                        </div>
                      ) : (
                        <p>
                          Didn’t receive the code? Resend in 00:
                          {timer.toString().padStart(2, "0")}
                        </p>
                      )}
                    </div>

                  </div>

                </div>

        {/* Submit */}
        <Button
          size="lg"
          variant="primary"
          className="w-full mt-5"
          onClick={handleVerification}
          type="button"
        >
          {loading ? (
            <ClockLoader color="#ffffff" loading={loading} size={20} />
          ) : (
            "Verify"
          )}

        </Button>
      </div>

      {/* Divider */}
      <div className="my-5 flex items-center gap-3">
        <div className="flex-1 border-t border-gray-200 dark:border-gray-700" />
        <span className="text-xs text-[#7B7B7B] font-semibold dark:text-gray-500">OR</span>
        <div className="flex-1 border-t border-gray-200 dark:border-gray-700" />
      </div>

      {/* Google */}
      <button
        type="button"
        // onClick={() => alert("Trigger Google Sign-In Logic")}
        className="flex items-center justify-center w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-700 dark:text-gray-300 font-medium bg-white dark:bg-transparent hover:bg-gray-50 dark:hover:bg-gray-800 hover:border-gray-400 dark:hover:border-gray-500 transition-all shadow-sm"
      >
        <GoogleIcon />
        Continue with Google
      </button>

      {/* Sign up */}
      <p className="mt-5 text-center text-xs text-gray-500 dark:text-gray-400">
                Already have an account?{" "}
                <Link to="/login" className="text-[#4338CA] dark:text-indigo-400 underline hover:text-violet-700 dark:hover:text-violet-300 font-semibold transition-colors">
                    Sign In
                </Link>
            </p>
    </AuthLayout>
  );
};

export default VerifyResetPassword;